var _rect, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntakeMoreInsightsIconContained(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 25,
    viewBox: "0 0 36 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.62,
    height: 25,
    rx: 6,
    fill: "#F3F8FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7695 18.573C13.7695 18.716 13.6525 18.833 13.5095 18.833H11.9573C11.8143 18.833 11.6973 18.716 11.6973 18.573C11.6973 18.43 11.8143 18.313 11.9573 18.313H13.5095C13.6525 18.313 13.7695 18.43 13.7695 18.573Z",
    fill: "#3B4651"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6482 17.3694C14.6482 17.5124 14.5312 17.6294 14.3882 17.6294H11.0784C10.9354 17.6294 10.8184 17.5124 10.8184 17.3694C10.8184 17.2264 10.9354 17.1094 11.0784 17.1094H14.3882C14.5312 17.1094 14.6482 17.2264 14.6482 17.3694Z",
    fill: "#3B4651"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0003 7.14078C15.0565 6.23858 13.8137 5.77838 12.5059 5.83818C10.1191 5.94998 8.14307 7.90518 8.00787 10.2894C7.93507 11.5712 8.36927 12.7984 9.23247 13.7448C9.85387 14.426 10.1945 15.2684 10.1945 16.116V16.1654C10.1945 16.311 10.3115 16.4254 10.4545 16.4254H15.0123C15.1553 16.4254 15.2723 16.311 15.2723 16.1654V16.116C15.2723 15.2476 15.5973 14.426 16.1875 13.7968C17.0117 12.918 17.4667 11.7688 17.4667 10.565C17.4667 9.25979 16.9467 8.04299 16.0003 7.14078Z",
    fill: "#2B79C2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1523 18.74C24.1523 18.883 24.0353 19 23.8923 19H22.3401C22.1971 19 22.0801 18.883 22.0801 18.74C22.0801 18.597 22.1971 18.48 22.3401 18.48H23.8923C24.0353 18.48 24.1523 18.597 24.1523 18.74Z",
    fill: "#3B4651"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.031 17.5364C25.031 17.6794 24.914 17.7964 24.771 17.7964H21.4612C21.3182 17.7964 21.2012 17.6794 21.2012 17.5364C21.2012 17.3934 21.3182 17.2764 21.4612 17.2764H24.771C24.914 17.2764 25.031 17.3934 25.031 17.5364Z",
    fill: "#3B4651"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3831 7.30778C25.4393 6.40557 24.1965 5.94537 22.8887 6.00517C20.5019 6.11697 18.5259 8.07218 18.3907 10.4564C18.3179 11.7382 18.7521 12.9654 19.6153 13.9118C20.2367 14.593 20.5773 15.4354 20.5773 16.283V16.3324C20.5773 16.478 20.6943 16.5924 20.8373 16.5924H25.3951C25.5381 16.5924 25.6551 16.478 25.6551 16.3324V16.283C25.6551 15.4146 25.9801 14.593 26.5703 13.9638C27.3945 13.085 27.8495 11.9358 27.8495 10.732C27.8495 9.42678 27.3295 8.20998 26.3831 7.30778Z",
    fill: "#2B79C2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntakeMoreInsightsIconContained);
export default __webpack_public_path__ + "static/media/intake-more-insights-icon-contained.1d9a02813841419309ff6b2081f586c7.svg";
export { ForwardRef as ReactComponent };